import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	filtro: {
		id_tipo: null,
		id_evento: null,
		id_unidade: null,
		id_veiculo: null,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaTipo: [],
	listaEvento: [],
	listaUnidade: [],
	listaVeiculo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ACESSORIO_HISTORICO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'ACESSORIO_HISTORICO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'ACESSORIO_HISTORICO_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'ACESSORIO_HISTORICO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

         case 'ACESSORIO_HISTORICO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

		case 'ACESSORIO_HISTORICO_EVENTO_SELECT_LISTADO':
			return {
				...state,
				listaEvento: action.payload.data
			};
			
        case 'ACESSORIO_HISTORICO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

        case 'ACESSORIO_HISTORICO_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
			};
        default:
            return state;
    }
}
